/* eslint-disable react/prop-types */
import React from 'react';
import {
  Col,
  DatePicker,
  Form,
  Input,
  Row,
} from 'antd';
import CurrencyInput from 'components/CurrencyInput';

const ExpedienteDatosOperacionales = ({
  form,
}) => (
  <Form
    layout="vertical"
    form={form}
    scrollToFirstError
    name="general"
    disabled
  >
    <Row gutter={10}>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="tipo_empleado"
          label="Tipo de Empleado"
        >
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="tipo_nomina_empleado"
          label="Tipo de Nómina Empleado"
        >
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="area_content_id"
          label="Área"
        >
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="puesto"
          label="Puesto"
        >
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="categoria_puesto"
          label="Categoría de Puesto"
        >
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <CurrencyInput
          name="sueldo_mensual"
          label="Sueldo Mensual del Empleado"
          disabled
        />
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="plaza"
          label="Plaza"
        >
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="fecha_alta"
          label="Fecha de Alta"
        >
          <DatePicker
            format="DD/MM/YYYY"
            placeholder={false}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="fecha_baja"
          label="Fecha de Baja"
        >
          <DatePicker
            format="DD/MM/YYYY"
            placeholder={false}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="fecha_reingreso"
          label="Fecha de Reingreso"
        >
          <DatePicker
            format="DD/MM/YYYY"
            placeholder={false}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="fecha_jubilacion"
          label="Fecha de Jubilación"
        >
          <DatePicker
            format="DD/MM/YYYY"
            placeholder={false}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="clave_liquidacion"
          label="Clave de Liquidación"
        >
          <Input />
        </Form.Item>
      </Col>
    </Row>
  </Form>
);

export default ExpedienteDatosOperacionales;
